import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=44f0fae8&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=ts"
export * from "./Promotions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f0fae8",
  null
  
)

export default component.exports